import { useLocale } from '@solinkcorp/locale';
import { SimpleFormField } from '@solinkcorp/solink-ui/components/Form';
import { NumberInputGroup } from '@solinkcorp/solink-ui/components/NumberInputGroup';
import React from 'react';
import { type UseFormReturn } from 'react-hook-form';
import {
  DEFAULT_LIVE_FEED_ROTATION_SECONDS,
  MAX_LIVE_FEED_ROTATION_SECONDS,
  MIN_LIVE_FEED_ROTATION_SECONDS,
} from '../../constants';
import { type WidgetFormData } from './schema';

interface LiveFeedWidgetSettingsProps {
  form: UseFormReturn<WidgetFormData>;
}

/**
 * Shows settings specific to live feed widgets.
 *
 * This is intended to be displayed as a child of `WidgetDialog`.
 */
export const LiveFeedWidgetSettings: React.FC<LiveFeedWidgetSettingsProps> = ({ form }) => {
  const locale = useLocale();

  return (
    <SimpleFormField
      control={form.control}
      name="rotationSeconds"
      label={locale.serviceDisplayMonitor.rotationInterval}
      description={locale.serviceDisplayMonitor.chooseRotationInterval}
      render={({ field }) => (
        // NumberInputGroup does not forward extra props, so the test id goes on a wrapper.
        <div data-testid="sdm-live-feed-rotation-interval">
          <NumberInputGroup
            placeholder={`${DEFAULT_LIVE_FEED_ROTATION_SECONDS}`}
            min={MIN_LIVE_FEED_ROTATION_SECONDS}
            max={MAX_LIVE_FEED_ROTATION_SECONDS}
            value={field.value}
            onChange={(value) => field.onChange(value)}
            suffix="sec"
          />
        </div>
      )}
    />
  );
};
